module.exports = __webpack_public_path__ + "media/images/slide-23-ae164be9cfbb9960aa2c1cb3998e97af.jpg";